var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaIzquierdaHover24X24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80755 11.7071C6.66311 11.8757 6.66311 12.1243 6.80755 12.2928L12.1382 18.5119C12.4077 18.8264 12.3713 19.2999 12.0568 19.5694C11.7423 19.839 11.2689 19.8026 10.9993 19.4881L5.66867 13.269C5.04274 12.5388 5.04274 11.4612 5.66867 10.7309L10.9993 4.51189C11.2688 4.1974 11.7423 4.16098 12.0568 4.43054C12.3713 4.70011 12.4077 5.17359 12.1382 5.48808L6.80755 11.7071Z",
    fill: "#6CD39B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31873 12C5.31873 12.4142 5.65451 12.75 6.06873 12.75H18.5687C18.9829 12.75 19.3187 12.4142 19.3187 12C19.3187 11.5858 18.9829 11.25 18.5687 11.25H6.06873C5.65451 11.25 5.31873 11.5858 5.31873 12Z",
    fill: "#6CD39B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaIzquierdaHover24X24);
export default __webpack_public_path__ + "static/media/FLECHA_IZQUIERDA_HOVER_24X24.e775e7c735cb612394400aa4069f9588.svg";
export { ForwardRef as ReactComponent };